var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/generic-slider.j2"] = require( "macros/generic-slider.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-visually-similar.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/generic-slider.j2", false, "product/templates/product-visually-similar.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericSlider")) {
var t_4 = t_1.genericSlider;
} else {
cb(new Error("cannot import 'genericSlider'")); return;
}
context.setVariable("genericSlider", t_4);
output += "<div class=\"dom-product-visually-similar c-product-visually-simililar\">\n    ";
var t_5;
t_5 = (lineno = 3, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.rrRecs.pdp3"]));
frame.set("recommendedProducts", t_5, true);
if(frame.topLevel) {
context.setVariable("recommendedProducts", t_5);
}
if(frame.topLevel) {
context.addExport("recommendedProducts", t_5);
}
output += "\n\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--12\">\n            <h3 class=\"c-product-visually-simililar__heading\">\n                ";
output += runtime.suppressValue((lineno = 8, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-oos-rec-tray_lead-message"])), env.opts.autoescape);
output += "\n            </h3>\n\n            <p class=\"c-product-visually-simililar__message\">\n                ";
output += runtime.suppressValue((lineno = 12, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-oos-rec-tray_supporting-message"])), env.opts.autoescape);
output += "\n            </p>\n        </div>\n    </div>\n\n    <div class=\"c-product-visually-simililar__recommendations u-clearfix\">\n        ";
output += runtime.suppressValue((lineno = 18, colno = 22, runtime.callWrap(t_4, "genericSlider", context, [runtime.contextOrFrameLookup(context, frame, "recommendedProducts"),runtime.makeKeywordArgs({"usePlaceholder": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
output += "\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-visually-similar.j2"] , dependencies)